import { Form, Input, Button } from 'antd';
import Axios from 'axios';
import React, { useState } from 'react';

function AddFriendPage(props) {

    const [Name, setName] = useState();
    const [Phone, setPhone] = useState();

    const onSubmit = (event) => {
        event.preventDefault();

        if(!Name || Name.length < 1){
            alert('올바른 이름을 입력해주세요');
            return;
        }
        if(!Phone || Phone.length < 1){
            alert('올바른 전화번호를 입력해주세요');
            return;
        }

        const variables = {
            requestor: props.user.userData._id,
            name: Name,
            phone: Phone            
        };

        console.log(variables);

        Axios.post('/api/user/requestFriend', variables)
            .then(response => {
                console.log(response)
                if (response.data.success) {
                    alert('친구신청을 보냈습니다')
                    props.history.push('/')
                } else {
                    alert(response.data.reason)
                }
            })
            .catch(err => console.log(err));
            
    };

    return <div className='page'>
        <Form onSubmit={onSubmit} >

            <br /><br />
            <label>친구 이름</label>
            <Input name='name' onChange={evnt => setName(evnt.currentTarget.value)}/>

            <br /><br />
            <label>친구 전화번호</label>
            <Input name='phone' onChange={evnt => setPhone(evnt.currentTarget.value)} />

            <br /><br />
            <Button
                size="large" type="primary"
                onClick={onSubmit}
            >
                친구추가하기
            </Button>

        </Form>
    </div>;
}

export default AddFriendPage;
